import React from 'react';
import '../../../v2-theme.css';

/**
 * V2Container Component
 *
 * Content wrapper with consistent max-width and padding
 * Matches container styles from HTML files
 *
 * @param {string} maxWidth - Max width size ('sm' | 'md' | 'lg' | 'xl' | 'full')
 * @param {React.ReactNode} children - Container content
 */
const V2Container = ({
  maxWidth = 'lg',
  className = '',
  children,
  ...props
}) => {
  const getWidthClass = () => {
    switch (maxWidth) {
      case 'sm':
        return 'v2-container-sm'; // 600px
      case 'md':
        return 'v2-container-md'; // 900px
      case 'lg':
        return 'v2-container-lg'; // 1200px
      case 'xl':
        return 'v2-container-xl'; // 1400px
      case 'full':
        return 'v2-container-full'; // 100%
      default:
        return 'v2-container-lg';
    }
  };

  const containerClasses = [
    'v2-container',
    getWidthClass(),
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} {...props}>
      {children}
    </div>
  );
};

export default V2Container;
